export default Object.freeze({
  ITEM_UNAVAILABLE: 'ITEM_UNAVAILABLE',
  QUANTITY_PER_ITEM_EXCEEDED: 'QUANTITY_PER_ITEM_EXCEEDED',
  TOTAL_QUANTITY_EXCEEDED: 'TOTAL_QUANTITY_EXCEEDED',
});
